import type { TFunction } from "i18next"
import { TProductFrequency } from "../types/Product"

const FREQUENCY_KEYS = {
  [TProductFrequency.Weekly]: "frequency.weekly",
  [TProductFrequency.Monthly]: "frequency.monthly",
  [TProductFrequency.Bimonthly]: "frequency.bimonthly",
  [TProductFrequency.Quarterly]: "frequency.quarterly",
  [TProductFrequency.Semester]: "frequency.semester",
  [TProductFrequency.Yearly]: "frequency.yearly",
} as const

/**
 * Período da assinatura no idioma atual. Em pt-BR devolve o mesmo texto de
 * Convertions.productFrequencyToType ("Mês", "Ano"...); vazio quando não há frequência.
 */
export const translateFrequency = (t: TFunction, frequency?: TProductFrequency | null) => {
  if (!frequency) return ""
  const key = FREQUENCY_KEYS[frequency as keyof typeof FREQUENCY_KEYS]
  return key ? t(key) : ""
}
